var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PublicCompCardBody',{attrs:{"comp":_vm.comp}},[_c('div',{attrs:{"slot":"close-top-right"},slot:"close-top-right"}),_vm._v(" "),_c('div',{attrs:{"slot":"close"},slot:"close"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }